module.exports = __webpack_public_path__ + "img/lifechamps-file.b127eab6.svg";